// Exposing all callables to the client

export { callables as workspaces } from "./workspaces/callables";
export { callables as presentations } from "./presentations/callables";
export { callables as slides } from "./slides/callables";
export { callables as clientLogs } from "./clientLogs/callables";
export { callables as experiments } from "./experiments/callables";
export { callables as debug } from "./debug/callables";

